import ZkOptionGroup from '../select/src/option-group';

/* istanbul ignore next */
ZkOptionGroup.install = function(Vue) {
  Vue.component(ZkOptionGroup.name, ZkOptionGroup);
};

export default ZkOptionGroup;



// WEBPACK FOOTER //
// ./src/packages/option-group/index.js